import { AvatarColors, hasCustomColor, hashString } from '../../utils/colors';

export const getAvatarProps = (
  name: string,
  color?: string
): { letter: string; bgColor: string } => {
  const trimmed = name.trim();
  const letter = trimmed.charAt(0).toUpperCase() || '?';
  const bgColor = hasCustomColor(color)
    ? color
    : AvatarColors[hashString(trimmed) % AvatarColors.length];
  return { letter, bgColor };
};
